
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItemIcon, ListItemText, Menu, Stack,
    Tooltip
} from "@mui/material";

// App Imports

import {
    deleteSubscriber, subscriberSearch
} from "./SubscriberClient";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeSubscriber} from "./subscriberSlice";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import SubscriberDrawer from "./SubscriberDrawer";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import Button from "@mui/material/Button";
import {changeUploadFile} from "../../CommonComponents/UploadFile/uploadFileSlice";
import UploadFileDrawer from "../../CommonComponents/UploadFile/UploadFileDrawer";
import SearchIcon from "@mui/icons-material/Search";
import SubscriberSearch from "./SubscriberSearch";
import AddFiltersExportToolbar from "../../CommonComponents/AddFiltersExportToolbar";
import {UsageGridColumns} from "../Usage/UsageGridColumns";
import {changeUsage} from "../Usage/usageSlice";
import {SubscriberGridColumns} from "./SubscriberGridColumns";
import {changeExternalData} from "../externalDataSlice";
import NoSearchCriteriaSnackbar from "../../CommonComponents/NoSearchCriteriaSnackbar";
import SubscriberInfoDialogue from "./Info/SubscriberInfoDialogue";

// main function
export default function SubscriberGrid() {

    // ****************** BEGIN STATES ****************************

    const [subscribers, setSubscribers] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showSearch, setShowSearch] = useState(false);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const [subscriberInfoOpen, setSubscriberInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorSubscriberId = useSelector((state) => state.subscriberSlc.value.id);
    const selectorSubscriberMcode = useSelector((state) => state.subscriberSlc.value.mcode);
    const selectorSubscriberName = useSelector((state) => state.subscriberSlc.value.name);
    const selectorSubscriberDescription = useSelector((state) => state.subscriberSlc.value.description);
    const selectorSubscriberCategory = useSelector((state) => state.subscriberSlc.value.category);
    const selectorDrawerState = useSelector((state) => state.subscriberSlc.value.subscriberDrawerState);
    const selectorUploadFileDrawerState = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerState);

    const selectorId = useSelector((state) => state.subscriberSearchSlc.value.id);
    const selectorExternalId = useSelector((state) => state.subscriberSearchSlc.value.externalId);
    const selectorPlatformId = useSelector((state) => state.subscriberSearchSlc.value.platformId);
    const selectorPlatformName = useSelector((state) => state.subscriberSearchSlc.value.platformName);
    const selectorService = useSelector((state) => state.subscriberSearchSlc.value.service);
    const selectorCountDateFrom = useSelector((state) => state.subscriberSearchSlc.value.countDateFrom);
    const selectorCountDateTo = useSelector((state) => state.subscriberSearchSlc.value.countDateTo);
    const selectorSubCountFrom = useSelector((state) => state.subscriberSearchSlc.value.subCountFrom);
    const selectorSubCountTo = useSelector((state) => state.subscriberSearchSlc.value.subCountTo);
    const selectorSource = useSelector((state) => state.subscriberSearchSlc.value.source);

    const selectedId = useSelector((state) => state.subscriberSlc.value.id);

    const dispatchData = useDispatch();

    const selectorSubscriberGridRefresh = useSelector((state) => state.subscriberSlc.value.subscriberGridRefresh);

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    // const fetchSubscribers = () =>{
    //     if(
    //         selectorId !== null ||
    //             selectorExternalId !== null ||
    //             selectorPlatformId !== null ||
    //             selectorPlatformName !== null ||
    //             selectorService !== null ||
    //             selectorCountDateFrom !== null ||
    //             selectorCountDateTo !== null ||
    //             selectorSubCountFrom !== null ||
    //             selectorSubCountTo !== null ||
    //             selectorSource !== null
    //     )
    //     {
    //         {
    //             subscriberSearch(
    //                 selectorId,
    //                 selectorExternalId,
    //                 selectorPlatformId,
    //                 selectorPlatformName,
    //                 selectorService,
    //                 selectorCountDateFrom,
    //                 selectorCountDateTo,
    //                 selectorSubCountFrom,
    //                 selectorSubCountTo,
    //                 selectorSource
    //             )

    //                 .then(data => {
    //                         console.log(data);
    //                         setSubscribers(data);
    //                     }
    //                 )
    //         }
    //     }
    //     else{console.log("search triggered, nothing to search.")}}
    //

    const fetchSubscribers = () => {

        const request = {

            id: selectorId,

            externalId: selectorExternalId,

            platformId: selectorPlatformId,

            platformName: selectorPlatformName,

            service: selectorService,

            countDateFrom: selectorCountDateFrom,
            countDateTo: selectorCountDateTo,

            subCountFrom: selectorSubCountFrom,
            subCountTo: selectorSubCountTo,

            source: selectorSource
        };

        console.log(
            JSON.stringify(request, null, 2)
        );

        const hasSearchCriteria = Object.values(request).some(
            value =>
                value !== null &&
                value !== undefined &&
                value !== ''
        );

        if (hasSearchCriteria) {

            dispatchData(changeExternalData({ submitting: true }));

            subscriberSearch(request)

                .then(data => {

                    console.log(data);

                    setSubscribers(data);


                    if (!data || data.length === 0) {
                        console.log("no matching records found");
                        dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "info", snackbarMessage: "No matching records found" }));
                    }


                })

                .catch(err => {

                    console.error(err);

                })

                .finally(() => {

                    // setSubmitting(false);
                    dispatchData(changeExternalData({ submitting: false }));
                });


        } else {

            console.log(
                "search triggered, nothing to search."
            );
            dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "warning", snackbarMessage: "No search criteria provided" }));
        }
    };

    // ****************** END FETCH ****************************

    const renderSubscribers = subscribers => {
        if (subscribers.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }
    //
    // useEffect(() => {
    //     fetchSubscribers();
    //     dispatchData(changeSubscriber({subscriberGridRefresh: false}));
    // }, [useSelector((state) => state.subscriberSlc.value.subscriberGridRefresh)===true]);

    useEffect(() => {

        if (selectorSubscriberGridRefresh) {

            fetchSubscribers();

            dispatchData(changeSubscriber({
                subscriberGridRefresh: false
            }));
        }

    }, [selectorSubscriberGridRefresh]);

    function handleSearch(){
        setShowSearch(!showSearch)
    }

    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeSubscriber({id: null, externalId: null, service: null, source: null,
            subCount: null, countDate: null, status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            subscriberDrawerState: true, subscriberDrawerMode: "Add"}));
    };


    const handleUploadFileDrawer = () => {
        console.log("upload file drawer state changed");
        dispatchData(changeUploadFile({uploadFileDrawerState: true,
            uploadFileDrawerMode: "Subscriber"}));
    };

    const removeSubscriber = () => {
        deleteSubscriber(selectorSubscriberId).then(() => {
            // successNotification("Data Point Attribute deleted", `Data Point Attribute with id ${selectorSubscriberId} was deleted`);
            setDeleteOpen(false);
            dispatchData(changeSubscriber({subscriberGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    };

    function DeleteConfirmationDialog() {
        // const [open, setOpen] = useState(false);

        const handleClickOpen = () => {
            setDeleteOpen(true);
        };

        const handleClose = () => {
            setDeleteOpen(false);
        };


        const handleDelete = () => {
            // Place your delete logic here
            deleteSubscriber(selectedId).then(() => {
                // successNotification("Data Point Attribute deleted", `Data Point Attribute with id ${selectorFinancialId} was deleted`);
                setDeleteOpen(false);
                dispatchData(changeSubscriber({subscriberGridRefresh: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            })
            console.log('Item deleted');
        };

        return (
            <Dialog
                open={deleteOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent', // makes backdrop transparent
                        boxShadow: '0 0 10px 5px rgba(0, 0, 0, 0.5)' // custom shadow box effect
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this item? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };
    // ****************** END CRUD ***********************************


    const gridClear = () => {

        setSubscribers([]);
    }


    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (subscribers) => {

        console.log('Subscriber data from clicked row');
        console.log(subscribers);
        dispatchData(changeSubscriber({id: subscribers.id, externalId: subscribers.externalId,
            service: subscribers.service, source: subscribers.source,
            subCount: subscribers.subCount, countDate: subscribers.countDate, status: subscribers.status,
            createdOn: subscribers.createdOn,createdBy:subscribers.createdBy,
            lastModifiedOn:subscribers.lastModifiedOn,lastModifiedBy:subscribers.lastModifiedBy}));
    };

    const handleSubscriberInfo = () => {
        setSubscriberInfoOpen(true);
    };

    const handleCloseSubscriberInfo = () => {
        setSubscriberInfoOpen(false);
    };



    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 80, pt: 1, pl: 3}}>
                <Stack direction={"horizontal"}>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                    <h3
                        style={{cursor:'pointer'}}   onClick={() => handleSubscriberInfo()}
                    >Subscribers</h3>
                    </Tooltip>
                        <SubscriberInfoDialogue
                            open={subscriberInfoOpen}
                            onClose={handleCloseSubscriberInfo}
                        />
                    {/*<SearchIcon*/}
                    {/*    sx={{pt: 2, ml: 2}}*/}
                    {/*    color={'primary'}*/}
                    {/*    onClick={handleSearch}*/}
                    {/*/>*/}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            color="primary"
                            size="large"               // large icon & hit area
                            onClick={handleSearch}
                            sx={{ ml: 2 }}             // any spacing you want
                        >
                            <SearchIcon fontSize="inherit" />
                        </IconButton>
                    </Box>
                    <Button sx={{pt: 1, ml: 3}}
                            onClick={handleUploadFileDrawer}
                    >Upload</Button>
                </Stack>
            </Box>
            {showSearch && <SubscriberSearch
                gridClear = {gridClear}
            />}
            {selectorUploadFileDrawerState && <UploadFileDrawer/>}
            {selectorDrawerState && <SubscriberDrawer
            />}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Subscribers"}
                rows={subscribers}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={SubscriberGridColumns({
                    hideActions,
                    onEdit: () => dispatchData(changeSubscriber({ subscriberDrawerState: true, subscriberDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeSubscriber({ subscriberDrawerState: true, subscriberDrawerMode: "Clone" })),
                    onDelete: removeSubscriber
                })}
                onRowClick = {(subscribers)=>handleClickedRow(subscribers.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={subscriber => subscriber.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
            <NoSearchCriteriaSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}



